// UI helpers: identities and permissions are always checked by the backend.
export function invitationError(error, fallback = 'Åtgärden kunde inte slutföras. Försök igen.') {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' ? detail : fallback;
}

export function invitationIdentity(invite, user) {
  const usernameFlow = invite?.login_mode === 'username' && !!invite?.username;
  const raw = Object.prototype.hasOwnProperty.call(invite || {}, 'login_email')
    ? invite.login_email : (invite?.email_is_delivery_only || usernameFlow ? null : invite?.email);
  const loginEmail = typeof raw === 'string' ? raw.trim().toLowerCase() : '';
  const currentEmail = typeof user?.email === 'string' ? user.email.trim().toLowerCase() : '';
  return { usernameFlow, loginEmail,
    mismatch: !!user && (usernameFlow || !loginEmail || !currentEmail || loginEmail !== currentEmail) };
}

export function invitationNextStep(error) {
  const status = error?.response?.status;
  if (!status || status >= 500 || status === 429) return 'Kontrollera anslutningen och försök hämta inbjudan igen om en stund.';
  if (status === 403) return 'Kontot kan inte användas för den här inbjudan. Kontakta lagets administratör.';
  return 'Använd den senaste inbjudan i mejlen. Har du redan accepterat den kan du logga in. Annars ber du ledaren skicka en ny länk.';
}

export async function submitInvitationBatch(teamId, review, api, isCurrent = () => true, onUpdate = () => {}) {
  const result = [];
  for (const item of review.items) {
    if (!isCurrent()) break;
    let row = { ...item, status: 'failed' };
    try {
      if (review.kind === 'link') {
        await api.createGuardianLink(teamId, { parent_user_id: review.userId,
          player_profile_id: item.playerId, relation: review.relation });
        row.status = 'linked';
        row.message = 'Barnkopplingen har skapats. Befintlig lagroll behålls.';
      } else {
        const { data } = await api.createPersonalInvitation({ name: review.name, email: review.email,
          role: review.role, team_id: teamId, ...(item.playerId ? { player_profile_id: item.playerId } : {}) });
        row.invitationId = data?.invitation?.id;
        if (data?.email_sent === true) {
          row.status = 'sent'; row.message = `Inbjudan skickad till ${data.invitation?.email || review.email}.`;
        } else if (row.invitationId) {
          row.status = 'saved_unsent'; row.message = 'Inbjudan sparades, men mejlet skickades inte. Skicka igen från inbjudningslistan.';
        } else {
          row.status = 'unknown'; row.message = 'Resultatet kunde inte bekräftas. Kontrollera inbjudningslistan innan du skickar igen.';
        }
      }
    } catch (error) {
      const status = error?.response?.status;
      row.status = !status || status >= 500 ? 'unknown' : 'failed';
      row.message = invitationError(error, review.kind === 'link'
        ? 'Kopplingen kunde inte bekräftas. Kontrollera barnkopplingarna innan du försöker igen.'
        : 'Utskicket kunde inte bekräftas. Kontrollera inbjudningslistan innan du försöker igen.');
    }
    result.push(row);
    if (isCurrent()) onUpdate([...result]);
  }
  return result;
}
